import React from 'react';

import {
  EMPLOYMENT_BASIS_OPTIONS,
  EMPLOYMENT_BASIS_WITH_MATERNITY_LEAVE_OPTIONS,
  FIELD_PATHS,
} from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';

import { DropdownField, StringDisplay } from '../../Fields';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface EmploymentBasisFunnelViewProps extends FunnelViewProps, EmploymentEntityIndex {}

export const EmploymentBasisFunnelView = (props: EmploymentBasisFunnelViewProps) => {
  const { employmentIndex = 0, ...rest } = props;

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_EMPLOYMENT_BASIS(employmentIndex)}
      label="Employment basis"
      options={EMPLOYMENT_BASIS_WITH_MATERNITY_LEAVE_OPTIONS}
    />
  );
};

export const EmploymentBasisReadOnlyView = (props: StringReadOnlyViewProps) => {
  return <StringDisplay title={'Employment basis'} value={props.value} />;
};

interface EmploymentBasisEditableViewProps extends EditableViewProps, EmploymentEntityIndex {
  isPrevious?: boolean;
}

export const EmploymentBasisEditableView = (props: EmploymentBasisEditableViewProps) => {
  const { employmentIndex = 0, isPrevious, ...rest } = props;

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_EMPLOYMENT_BASIS(employmentIndex)}
      label="Employment basis"
      options={isPrevious ? EMPLOYMENT_BASIS_OPTIONS : EMPLOYMENT_BASIS_WITH_MATERNITY_LEAVE_OPTIONS}
      validationFailMessage="Please select the Employment basis"
    />
  );
};
